import { contactItem } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {contactItem.description}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          <div className="rounded-2xl bg-background-100 p-5 md:p-6 text-center border border-background-200">
            <span className="inline-flex w-12 h-12 items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-3 text-xl">
              <i className="ri-mail-line"></i>
            </span>
            <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
            <div className="text-sm font-medium text-foreground-800 break-all">{contactItem.email}</div>
          </div>
          <div className="rounded-2xl bg-background-100 p-5 md:p-6 text-center border border-background-200">
            <span className="inline-flex w-12 h-12 items-center justify-center rounded-xl bg-accent-100 text-accent-500 mb-3 text-xl">
              <i className="ri-wechat-fill"></i>
            </span>
            <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
            <div className="text-sm font-medium text-foreground-800">{contactItem.wechat}</div>
          </div>
          <div className="rounded-2xl bg-background-100 p-5 md:p-6 text-center border border-background-200">
            <span className="inline-flex w-12 h-12 items-center justify-center rounded-xl bg-secondary-100 text-secondary-500 mb-3 text-xl">
              <i className="ri-qq-fill"></i>
            </span>
            <div className="text-xs text-foreground-500 mb-1">QQ群</div>
            <div className="text-sm font-medium text-foreground-800">{contactItem.qq}</div>
          </div>
        </div>
      </div>
    </section>
  );
}